import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog7() {
  pageTitle('10 Practical Steps to a More Sustainable Lifestyle');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="10 Practical Steps to a More Sustainable Lifestyle"
        variant="text-center"
        shape="shape_5"
        category="Sustainable Living"
        date="28 Dec 2024"
        avatar="Lifestyle"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Sustainable Living"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Transform Your Home into an Eco-Friendly Haven
          </h3>
          <p>
            Sustainable living isn't just about installing solar panels – it's a comprehensive approach to reducing your environmental impact while improving your quality of life. Discover practical steps that make a real difference.
          </p>
          <p>
            From energy-efficient appliances to smart home automation, learn how small changes can lead to significant environmental and financial benefits.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Energy Efficiency"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Smart Home"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Green Living"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Immediate Steps for a Greener Home</h3>
          <p>
            Start your sustainability journey with these proven strategies that combine renewable energy with smart living practices. Our experts at Soketry Solutions can help you implement these changes effectively.
          </p>
          <blockquote>
            "After implementing these sustainable living tips alongside our solar installation, our monthly utility bills dropped by 85%. The ROI has been incredible!"
            <small>Lisa Chen, Sustainable Home Pioneer</small>
          </blockquote>
          <p>
            Let Soketry Solutions guide you through your sustainability transformation with our comprehensive solutions and expert advice.
          </p>
          <ul>
            <li>Energy audit and optimization</li>
            <li>Smart thermostat installation</li>
            <li>LED lighting upgrades</li>
            <li>Water conservation systems</li>
            <li>Renewable energy integration</li>
            <li>Home insulation improvements</li>
            <li>Energy monitoring systems</li>
            <li>Sustainable landscaping tips</li>
            <li>Waste reduction strategies</li>
            <li>Electric vehicle charging solutions</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Sustainable Living
            </a>
            <a href="/" className="cs_category">
              Green Home
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your sustainable living tips"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 